import { render, staticRenderFns } from "./socialMobile2_ok.vue?vue&type=template&id=c4664596&scoped=true"
import script from "./socialMobile2_ok.vue?vue&type=script&lang=js"
export * from "./socialMobile2_ok.vue?vue&type=script&lang=js"
import style0 from "./socialMobile2_ok.vue?vue&type=style&index=0&id=c4664596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4664596",
  null
  
)

export default component.exports